let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3pTtv")).then(() => parcelRequire('4nb7z'));